import { apiClient } from "../config";

async function bulkArchiveObservations(
  observationIds: (string | number)[],
  status: string
) {
  const url = `/admin/observations/bulk-archive`;
  const res = await apiClient.put(url, null, {
    params: {
      observation_ids: observationIds.join(","),
      status,
    },
  });

  return res.data;
}

export default bulkArchiveObservations;
